/**
 * Admin "Preview as learner" mode (Round 116). While a preview is active in this tab, every learner API call (apiFetch,
 * the audio / sentence-TTS / background-save fetches) goes to /api/v1/preview/:previewId/... instead of /api/v1/...; the
 * backend then acts as a SANDBOX learner owned by this admin (src/services/lessonPreview.service.ts). Module-level state
 * on purpose: one preview per tab, gone when the tab closes.
 */
export interface ActivePreview { previewId: string; lessonId: string; level: string; title: string }

let active: ActivePreview | null = null;

export function setActivePreview(p: ActivePreview | null): void { active = p; }
export function getActivePreview(): ActivePreview | null { return active; }
export function isPreviewActive(): boolean { return active !== null; }

/**
 * Path infix every learner API URL must carry: '' normally, '/preview/<id>' during a preview, so the URL is
 * `${API_BASE}${previewPrefix()}/sessions/...`. (No import.meta here on purpose: Jest cannot parse it, and this module is
 * imported by many learner components.)
 */
export function previewPrefix(): string {
  return active ? `/preview/${active.previewId}` : '';
}
